import { FC } from "react";
import { MenuType } from "../../app/types/ProposalTypes";

interface MenuReciptProps {
  menu: MenuType;
  locale: string;
}

const MenuRecipt: FC<MenuReciptProps> = ({ menu, locale }) => {
  const total = menu.price * menu.quantity;
  return (
    <tr className="text-[18px] font-normal border-b border-gray-100">
      <td className="py-2 pr-4">
        <div>{menu.name[locale]}</div>
        {menu.description[locale] && (
          <div className="text-[14px] text-gray-400">
            {menu.description[locale]}
          </div>
        )}
      </td>
      <td className="py-2 pr-4 text-right">{menu.quantity}</td>
      <td className="py-2 pr-4 text-right">{menu.price},-</td>
      <td className="py-2 text-right">{total},-</td>
    </tr>
  );
};

export default MenuRecipt;
